module.exports = __webpack_public_path__ + "img/member_coupons_icon_431006.f9004ab7.png";